import React from "react"
import DocumentViewer from "components/Common/DocumentViewer"
//controls
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap"

const DocumentViewModal = ({show, fileUrl, fileType, onCloseClick }) => {
  return (
    <Modal
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="xl"
    >
      <ModalHeader className="d-flex justify-content-center">
        Document Viewer
      </ModalHeader>
      <ModalBody className="py-3 px-5">
      <DocumentViewer fileUrl={fileUrl} fileType={fileType} />
      </ModalBody>
      < ModalFooter>
        <div className="d-flex flex-wrap gap-2">
          <button
            type="button"
            className="btn btn btn-secondary"
            onClick={onCloseClick}
          >
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default DocumentViewModal
